module.exports = __webpack_public_path__ + "static/media/empty.8820d60e.svg";